// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Ke73","content":"Home_content__qrD-+","featured_stories":"Home_featured_stories__EbBcQ","latest":"Home_latest__apGKy"};